
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30473',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30473",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54853",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8124",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11580",
  "I18n": "static-7.1636",
  "quartz": "static-1.7162",
  "quartz-config": "static-1.940",
  "quartz-core": "static-1.6381",
  "react-dlb": "static-1.81",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.822",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.54840",
  "feedback-utils": "static-1.54844",
  "forms-embed-utils-lib": "static-1.4572",
  "forms-utils-lib": "static-1.12775",
  "foundations-assets": "static-1.4978",
  "foundations-components": "static-1.8136",
  "foundations-theming": "static-1.4535",
  "hub-http": "static-1.6328",
  "hubspot-url-utils": "static-1.4132",
  "HubStyle": "static-2.11887",
  "icons": "static-2.653",
  "immutable": "static-2.79",
  "quick-fetch": "static-1.3994",
  "raven": "static-3.5925",
  "react": "static-7.187",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16788",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5419",
  "react-virtualized": "static-2.100",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.489",
  "tinymce-plugins": "static-1.57752",
  "transmute": "static-2.85",
  "ui-images": "static-2.1179",
  "UIComponents": "static-3.8526",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3475",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3439",
  "quartz-webpack": "static-1.3386",
  "foundations-theming-specialty": "static-1.2251",
  "property-description-translator": "static-1.3947",
  "HeadJS": "static-2.767",
  "framer-motion": "static-1.73",
  "hs-test-utils-bend-plugin": "static-1.3235",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4432",
  "jasmine-runner": "static-1.6564",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.843",
  "hubspotter-http": "static-1.4728",
  "mobile-manifest-mixins": "static-1.542",
  "module-federation": "static-1.27",
  "quartz-auth": "static-1.837",
  "quartz-head": "static-1.827",
  "quartz-i18n": "static-1.837",
  "quartz-routing": "static-1.592",
  "quartz-test": "static-1.837",
  "quartz-tracking": "static-1.541",
  "trellis-components": "static-1.2201",
  "ui-fonts": "static-1.842",
  "usage-tracker-container": "static-1.7444",
  "usage-tracker-core": "static-1.7304",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.158",
  "conversations-skeleton-state": "static-1.7354",
  "reference-resolvers": "static-1.8280",
  "sanitize-text": "static-1.8250",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10468",
  "sanitize": "static-1.4582",
  "outpost": "static-1.4276",
  "rpc-client-utils": "static-1.4761",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4405",
  "floating-ui": "static-1.57",
  "hs-story-utils": "static-1.9528",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.34",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2182",
  "bend-plugin-foundations-theming": "static-1.3018",
  "foundations-theming-base": "static-1.3520",
  "stylex": "static-1.34",
  "hs-locale-management": "static-1.159",
  "csstype": "static-1.50",
  "web-vitals": "static-1.7",
  "ai-components-ui-library": "static-1.9209",
  "atom": "static-1.5180",
  "codemirror": "static-5.96",
  "content-assistance-lib": "static-1.7917",
  "ContentUtils": "static-1.68654",
  "data-token-picker": "static-1.16588",
  "file-manager-components": "static-1.23901",
  "FileManagerCore": "static-1.39400",
  "FileManagerLib": "static-1.39541",
  "frontend-preferences-client": "static-1.8033",
  "hub-http-contrib": "static-1.3148",
  "interframe": "static-3.4866",
  "layout-dnd-components": "static-1.12642",
  "layout-dnd-utils": "static-1.11617",
  "property-translator": "static-1.5503",
  "react-codemirror": "static-1.10733",
  "react-colorpicker": "static-2.10314",
  "reference-resolvers-lite": "static-1.8204",
  "rich-text-lib": "static-1.20009",
  "tinymce-data": "static-1.40723",
  "tinymce-themes": "static-1.56608",
  "ui-addon-emoji-picker": "static-1.9992",
  "ui-addon-sales-email": "static-1.5316",
  "ui-brand-identity-lib": "static-1.15643",
  "bender-build-tools": "static-1.3281",
  "hub-http-shared-msw-handlers": "static-1.10214",
  "hubspotter-http-shared-msw-handlers": "static-1.10212",
  "usage-tracker-session-replay": "static-1.5140",
  "base-ui": "static-1.13",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1047",
  "tanstack-virtual": "static-1.31",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.171",
  "chirp-fetch": "static-1.1992",
  "chatspot-core": "static-1.21786",
  "copilot-toolkit": "static-1.11396",
  "customer-data-objects-ui-components": "static-1.13136",
  "data-fetching-client": "static-1.9768",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4866",
  "ui-addon-video-player": "static-1.8809",
  "ui-coaching-tips": "static-1.28844",
  "usage-tracker": "static-1.7454",
  "cms-field-types": "static-1.4919",
  "content-icons-ui": "static-1.2256",
  "integrations-lib": "static-1.16486",
  "customer-data-objects": "static-1.7785",
  "apollo-dlb": "static-3.86",
  "apollo-link-hub-http": "static-2.4758",
  "apollo-stack-hubspot": "static-3.87",
  "graphql": "static-1.83",
  "immer": "static-1.33",
  "immerable": "static-1.4257",
  "ui-addon-iframeable": "static-1.9170",
  "video-components-external": "static-1.11610",
  "video-data-lib": "static-1.35268",
  "audio-components": "static-1.6074",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29487",
  "FileManagerImages": "static-1.37052",
  "foundations-components-legacy": "static-1.1161",
  "html-to-image": "static-1.55",
  "react-immutable-proptypes": "static-2.8",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "salesImages": "static-1.527",
  "ui-universal-auth": "static-1.9103",
  "urlinator": "static-1.4642",
  "video-components": "static-1.13612",
  "video-embed": "static-1.36102",
  "ts-schema": "static-1.4157",
  "ContentData": "static-1.68729",
  "layout-data-lib": "static-1.9942",
  "react-dnd-compat": "static-1.4721",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1648",
  "external-options-client-types": "static-1.4206",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.6997",
  "hs-promise-utils": "static-1.5697",
  "inbound-db-properties-service-client": "static-1.3922",
  "NamespacedHubStyle": "static-2.9133",
  "growth-onboarding-confetti": "static-1.3171",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11255",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1070",
  "magpie-lib": "static-1.5621",
  "magpie-types": "static-1.5081",
  "simple-logging-lib": "static-1.3156",
  "avatar-components": "static-1.2604",
  "customer-data-ui-utilities": "static-1.9931",
  "growth-onboarding-feedback-components": "static-1.6685",
  "flux-actions": "static-1.345",
  "hubspot-apollo-client": "static-1.4984",
  "integrations-error-boundary-lib": "static-1.13901",
  "integrations-tracking-lib": "static-1.5712",
  "laboratory-lib": "static-3.7258",
  "native-integrations-shared-strings": "static-1.7889",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10330",
  "unified-auth": "static-1.617",
  "navigation-messaging": "static-1.7591",
  "content-media-composition-data-lib": "static-1.12635",
  "content-media-compositions": "static-2.16642",
  "idb-keyval": "static-1.45",
  "media-bridge-lib": "static-1.19104",
  "unified-auth-core-lib": "static-1.899",
  "social-insights-client-types": "static-1.22323",
  "advanced-menus-core": "static-1.15294",
  "advanced-menus-lib": "static-1.12208",
  "ExportDialog": "static-6.10486",
  "ui-memberships-settings-lib": "static-1.34320",
  "conditional-properties-service-client": "static-1.3873",
  "crm-pipelines-api-client-types": "static-1.4215",
  "fdsr-migration-layer": "static-1.116",
  "framework-builder-read-service-client": "static-1.4081",
  "framework-data-schema-quick-fetch": "static-1.6902",
  "inbound-db-meta-service-client": "static-1.3663",
  "multi-currency-client-types": "static-1.3767",
  "persist-promise": "static-1.3805",
  "foundations-components-test-utils": "static-1.5619",
  "breeze-engine-core": "static-1.348",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "reactive-lib": "static-1.831",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.443",
  "universal-page-editor-lib": "static-1.3124",
  "ads-unified-auth-lib": "static-1.332",
  "google-sheets-integration-lib": "static-1.536",
  "microsoft-drive-integration-lib": "static-1.672",
  "slack-ui-library": "static-1.10500",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3835",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15293",
  "simple-menus-lib": "static-1.16810",
  "crm-record-cards-service-types": "static-1.3666",
  "location-customization-utils-lib": "static-1.9559",
  "react-flip-move": "static-1.72"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30473",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54853",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8124",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11580",
  "I18n": "/I18n/static-7.1636",
  "quartz": "/quartz/static-1.7162",
  "quartz-config": "/quartz-config/static-1.940",
  "quartz-core": "/quartz-core/static-1.6381",
  "react-dlb": "/react-dlb/static-1.81",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.822",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54840",
  "feedback-utils": "/feedback-utils/static-1.54844",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4572",
  "forms-utils-lib": "/forms-utils-lib/static-1.12775",
  "foundations-assets": "/foundations-assets/static-1.4978",
  "foundations-components": "/foundations-components/static-1.8136",
  "foundations-theming": "/foundations-theming/static-1.4535",
  "hub-http": "/hub-http/static-1.6328",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyle": "/HubStyle/static-2.11887",
  "icons": "/icons/static-2.653",
  "immutable": "/immutable/static-2.79",
  "quick-fetch": "/quick-fetch/static-1.3994",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.187",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16788",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5419",
  "react-virtualized": "/react-virtualized/static-2.100",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "tinymce-plugins": "/tinymce-plugins/static-1.57752",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1179",
  "UIComponents": "/UIComponents/static-3.8526",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3475",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3439",
  "quartz-webpack": "/quartz-webpack/static-1.3386",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2251",
  "property-description-translator": "/property-description-translator/static-1.3947",
  "HeadJS": "/HeadJS/static-2.767",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3235",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4432",
  "jasmine-runner": "/jasmine-runner/static-1.6564",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.843",
  "hubspotter-http": "/hubspotter-http/static-1.4728",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.542",
  "module-federation": "/module-federation/static-1.27",
  "quartz-auth": "/quartz-auth/static-1.837",
  "quartz-head": "/quartz-head/static-1.827",
  "quartz-i18n": "/quartz-i18n/static-1.837",
  "quartz-routing": "/quartz-routing/static-1.592",
  "quartz-test": "/quartz-test/static-1.837",
  "quartz-tracking": "/quartz-tracking/static-1.541",
  "trellis-components": "/trellis-components/static-1.2201",
  "ui-fonts": "/ui-fonts/static-1.842",
  "usage-tracker-container": "/usage-tracker-container/static-1.7444",
  "usage-tracker-core": "/usage-tracker-core/static-1.7304",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.158",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7354",
  "reference-resolvers": "/reference-resolvers/static-1.8280",
  "sanitize-text": "/sanitize-text/static-1.8250",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10468",
  "sanitize": "/sanitize/static-1.4582",
  "outpost": "/outpost/static-1.4276",
  "rpc-client-utils": "/rpc-client-utils/static-1.4761",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4405",
  "floating-ui": "/floating-ui/static-1.57",
  "hs-story-utils": "/hs-story-utils/static-1.9528",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.34",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2182",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3018",
  "foundations-theming-base": "/foundations-theming-base/static-1.3520",
  "stylex": "/stylex/static-1.34",
  "hs-locale-management": "/hs-locale-management/static-1.159",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.7",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9209",
  "atom": "/atom/static-1.5180",
  "codemirror": "/codemirror/static-5.96",
  "content-assistance-lib": "/content-assistance-lib/static-1.7917",
  "ContentUtils": "/ContentUtils/static-1.68654",
  "data-token-picker": "/data-token-picker/static-1.16588",
  "file-manager-components": "/file-manager-components/static-1.23901",
  "FileManagerCore": "/FileManagerCore/static-1.39400",
  "FileManagerLib": "/FileManagerLib/static-1.39541",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8033",
  "hub-http-contrib": "/hub-http-contrib/static-1.3148",
  "interframe": "/interframe/static-3.4866",
  "layout-dnd-components": "/layout-dnd-components/static-1.12642",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11617",
  "property-translator": "/property-translator/static-1.5503",
  "react-codemirror": "/react-codemirror/static-1.10733",
  "react-colorpicker": "/react-colorpicker/static-2.10314",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8204",
  "rich-text-lib": "/rich-text-lib/static-1.20009",
  "tinymce-data": "/tinymce-data/static-1.40723",
  "tinymce-themes": "/tinymce-themes/static-1.56608",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9992",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5316",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15643",
  "bender-build-tools": "/bender-build-tools/static-1.3281",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10214",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10212",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5140",
  "base-ui": "/base-ui/static-1.13",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1047",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.171",
  "chirp-fetch": "/chirp-fetch/static-1.1992",
  "chatspot-core": "/chatspot-core/static-1.21786",
  "copilot-toolkit": "/copilot-toolkit/static-1.11396",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13136",
  "data-fetching-client": "/data-fetching-client/static-1.9768",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4866",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8809",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28844",
  "usage-tracker": "/usage-tracker/static-1.7454",
  "cms-field-types": "/cms-field-types/static-1.4919",
  "content-icons-ui": "/content-icons-ui/static-1.2256",
  "integrations-lib": "/integrations-lib/static-1.16486",
  "customer-data-objects": "/customer-data-objects/static-1.7785",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4758",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.87",
  "graphql": "/graphql/static-1.83",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4257",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9170",
  "video-components-external": "/video-components-external/static-1.11610",
  "video-data-lib": "/video-data-lib/static-1.35268",
  "audio-components": "/audio-components/static-1.6074",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29487",
  "FileManagerImages": "/FileManagerImages/static-1.37052",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1161",
  "html-to-image": "/html-to-image/static-1.55",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "salesImages": "/salesImages/static-1.527",
  "ui-universal-auth": "/ui-universal-auth/static-1.9103",
  "urlinator": "/urlinator/static-1.4642",
  "video-components": "/video-components/static-1.13612",
  "video-embed": "/video-embed/static-1.36102",
  "ts-schema": "/ts-schema/static-1.4157",
  "ContentData": "/ContentData/static-1.68729",
  "layout-data-lib": "/layout-data-lib/static-1.9942",
  "react-dnd-compat": "/react-dnd-compat/static-1.4721",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1648",
  "external-options-client-types": "/external-options-client-types/static-1.4206",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6997",
  "hs-promise-utils": "/hs-promise-utils/static-1.5697",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3922",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9133",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3171",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11255",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1070",
  "magpie-lib": "/magpie-lib/static-1.5621",
  "magpie-types": "/magpie-types/static-1.5081",
  "simple-logging-lib": "/simple-logging-lib/static-1.3156",
  "avatar-components": "/avatar-components/static-1.2604",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9931",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6685",
  "flux-actions": "/flux-actions/static-1.345",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4984",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13901",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5712",
  "laboratory-lib": "/laboratory-lib/static-3.7258",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7889",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10330",
  "unified-auth": "/unified-auth/static-1.617",
  "navigation-messaging": "/navigation-messaging/static-1.7591",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12635",
  "content-media-compositions": "/content-media-compositions/static-2.16642",
  "idb-keyval": "/idb-keyval/static-1.45",
  "media-bridge-lib": "/media-bridge-lib/static-1.19104",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.899",
  "social-insights-client-types": "/social-insights-client-types/static-1.22323",
  "advanced-menus-core": "/advanced-menus-core/static-1.15294",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12208",
  "ExportDialog": "/ExportDialog/static-6.10486",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34320",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3873",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4215",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.116",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4081",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6902",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3663",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3767",
  "persist-promise": "/persist-promise/static-1.3805",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5619",
  "breeze-engine-core": "/breeze-engine-core/static-1.348",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "reactive-lib": "/reactive-lib/static-1.831",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.443",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3124",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.332",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.536",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.672",
  "slack-ui-library": "/slack-ui-library/static-1.10500",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3835",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15293",
  "simple-menus-lib": "/simple-menus-lib/static-1.16810",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3666",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9559",
  "react-flip-move": "/react-flip-move/static-1.72"
}
};
